<template>
<div class="container-main">
	<!-- <navHeader :headers="headers"></navHeader> -->
	<!-- 定向邀请 -->
	<template v-if="type==1">
		<vxe-table :data="list" class="mytable-scrollbar forms"
			stripe highlight-hover-row
			size="small">
			<vxe-column type="seq" title="序号" width="65"></vxe-column>
			<vxe-column field="invite_name" title="组织名称">
				<template #default="{row}">
					<textOver :text="row.invite_name"></textOver>
				</template>
			</vxe-column>
			<vxe-column field="invite_code" title="统一社会信用代码">
				<template #default="{row}">
					<textOver :text="row.invite_code"></textOver>
				</template>
			</vxe-column>
			<vxe-column field="invite_contact_name" title="管理员姓名"></vxe-column>
			<vxe-column field="invite_contact_mobile" title="联系方式"></vxe-column>
			<vxe-column field="join_date" title="提交时间"></vxe-column>
		</vxe-table>
	</template>
	<!-- end of 定向邀请 -->
	<!-- 公开邀请 -->
	<template v-if="type==2">
		<searchHeader :model="inputs" @search="searchBtn" class="search-box" />
		<vxe-table :data="list" class="mytable-scrollbar forms"
			stripe highlight-hover-row
			size="small">
			<vxe-column type="seq" title="序号" width="65"></vxe-column>
			<vxe-column field="invite_name" title="组织名称">
				<template #default="{row}">
					<textOver :text="row.invite_name"></textOver>
				</template>
			</vxe-column>
			<vxe-column field="invite_code" title="统一社会信用代码">
				<template #default="{row}">
					<textOver :text="row.invite_code"></textOver>
				</template>
			</vxe-column>
			<vxe-column field="invite_contact_name" title="管理员姓名"></vxe-column>
			<vxe-column field="invite_contact_mobile" title="联系方式"></vxe-column>
			<vxe-column field="join_date" title="提交时间"></vxe-column>
		</vxe-table>
		<pageNumber  @changePage="changePage" :pages="pages"></pageNumber>
	</template>
	<!-- end of 公开邀请 -->
</div>
</template>

<script>
	import pageNumber from "@/components/phmAll/pageNumber.vue";
	import textOver from '@/components/phmAll/textOver';
	import searchHeader from '@/components/phmAll/searchHeader'
	export default {
		components: {
			pageNumber,
			textOver,
			searchHeader,
		},
		data(){
			return {
				headers:{
					title:"邀请记录",
					back:true,
				},
				code:'',
				list:[{}],
				searchKey:{},
				type:0,
				pages: {
				  pageNum: 1,
				  pageSize: 10,
				  total: 10,
				},
				inputs:[
					{type:"input", field: "invite_name",label: "组织名称",value: ""},
					{type:"input", field: "invite_code",label: "统一社会信用代码",value: ""},
					{type:"input", field: "status",label: "管理员姓名",value: "",},
					{type:"input", field: "created_by",label: "联系方式",value: ""},
					{type:"time", field: "created_at",label: "提交时间",value:[]},
				],
				
			}
		},
		created(){
			let query = this.$route.query;
			if(query.code){
				this.code = query.code;
				this.getListData();
			}
			if(query.type){
				this.type =Number(query.type);
			}
			
		},
		mounted(){
			this.$store.commit("updatePageNav", [
			  { name: "邀请租户"},
			  { name: "邀请记录"},
			  { name: "详情"},
			]);
		},
		methods: {
			searchBtn(data){
				console.log('data',data);
				this.searchKey = data;
				this.getListData();
			},
			changePage(val){
				if (val.type == "size") {
				  this.pages.pageSize = val.num;
				} else {
				  this.pages.pageNum = val.num;
				}
				this.getListData();
			},
			getListData(){
				let params = {
					invite_serial_number:this.code,
					invite_place:1,
					page_size:this.pages.pageSize,
					page:this.pages.pageNum,
				};
				if(!this.$utils.isEmpty(this.searchKey)){
					let search = this.searchKey;
					for(let key in search){
						if(search[key]){
							params[key] = search[key]
						}
					}
				}
				this.$axios.postJSON('/base/invite/common/log/list',params).then(res=>{
					if(res.code == 200){
						let data = res.data;
						if(data){
							if(data.list){
								this.list = data.list;
								this.pages.total = data.total_count
							}
							
						}else{
							this.list = [];
							if(this.type==1){
								// this.$message.warning("该用户暂未激活")
							}
						}
					}
				}).catch(err=>{
					console.log(err);
					err.msg && this.$message.error(err.msg);
				})
			},
		},
	}
</script>

<style scoped lang="scss">
.container-main{
	margin:0 auto;
	width:1200px;
	padding: 20px;
	box-sizing: border-box;
	background-color: #FFFFFF;
}
.search-box{
	margin:20px 0;
}
</style>
